/**
 * Unconditional console logging for the chunked read path: every member
 * fetch/cache-hit/eviction, chunk parse, sidecar read, attachment
 * resolution, and row materialization, for confirming windowed-read
 * behavior while browsing. Deliberately NOT the gated `createLogger` —
 * the chunked path is dev-phase (only the hidden converter produces
 * chunked logs), and the point is to see the reads in any build. Dial
 * back to `createLogger("chunked")` before the format ships by default.
 */
export const log = {
  info: (message: string): void => {
    console.log(`[chunked] ${message}`);
  },
  debug: (message: string): void => {
    console.log(`[chunked] ${message}`);
  },
  error: (message: string): void => {
    console.error(`[chunked] ${message}`);
  },
};
